import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";

import ActionsCell from "./ActionCell";
import IdCell from "./IdCell";

export const redemptionHistoryColumns: GridColDef[] = [
  {
    field: "userRedemptionId",
    headerName: "ID",
    width: 250,
    valueGetter: item => ({
      userRedemptionId: item.row.userRedemptionId,
      userRewardId: item.row.userRewardId,
    }),
    renderCell: IdCell,
  },
  {
    field: "dateTime",
    headerName: "Date/ Time",
    width: 160,
    sortable: true,
    disableColumnMenu: true,
    valueGetter: ({ value }) => value && dayjs(value).format("DD/MM/YYYY"),
  },
  {
    field: "points",
    headerName: "Points (+/-)",
    width: 160,
    sortable: false,
    disableColumnMenu: true,
    renderCell: item =>
      item.row.type === "BURN"
        ? `- ${item.row.points}`
        : `+ ${item.row.points}`,
  },
  {
    field: "activityTypeName",
    headerName: "Category",
  },
  {
    field: "itemName",
    headerName: "Item name",
    width: 340,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "remarks",
    width: 280,
    headerName: "Remarks",
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 200,
    valueGetter: item => ({
      type: item.row.type,
      userRedemptionId: item.row.userRedemptionId,
      userRewardId: item.row.userRewardId,
      points: item.row.points,
      activityTypeName: item.row.activityTypeName,
      activityTypeId: item.row.activityTypeId,
      rewardTypeName: item.row.itemName,
      omneId: item.row.omneId,
      dateTime: item.row.dateTime,
    }),
    renderCell: ActionsCell,
    sortable: false,
    filterable: false,
  },
];
